export class NotAuth {
   constructor() {
      this.loginUrl = '#/login';
   }
}

